var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPopular = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M23.9431 4.96291C23.9065 4.87445 23.8522 4.79158 23.7803 4.71967C23.7084 4.64776 23.6255 4.59351 23.5371 4.55691C23.4487 4.52024 23.3517 4.5 23.25 4.5H23.2499H17.25C16.8358 4.5 16.5 4.83579 16.5 5.25C16.5 5.66421 16.8358 6 17.25 6H21.4393L13.5 13.9393L9.53033 9.96967C9.23744 9.67678 8.76256 9.67678 8.46967 9.96967L0.21967 18.2197C-0.0732233 18.5126 -0.0732233 18.9874 0.21967 19.2803C0.512563 19.5732 0.987437 19.5732 1.28033 19.2803L9 11.5607L12.9697 15.5303C13.2626 15.8232 13.7374 15.8232 14.0303 15.5303L22.5 7.06066V11.25C22.5 11.6642 22.8358 12 23.25 12C23.6642 12 24 11.6642 24 11.25V5.25147C24 5.24636 24 5.24126 23.9999 5.23616C23.9982 5.14309 23.9792 5.05028 23.9431 4.96291Z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgPopular);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/popular.2ccf467f185fcf6bc2020377cbbff5e0.svg";